import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  public msg: string;
  public title: string;
  public infoMode: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.msg = data.msg;
    this.title = data.title || '';
    this.infoMode = data.infoMode || false;
  }

  ngOnInit() {}
}
